export default import.meta.ROLLDOWN_FILE_URL_nMGFKCAb$q6PyYtU4pEbBQ